import React from "react";
import { Link } from "react-router-dom";
import "./PersonSection.scss";
export default function PersonSection({ data }) {
  return (
    <div className="person-section-wrapper">
      <div className="container">
        <div className="person-section-content">
          {data &&
            data.map((section, idx) => (
              <>
              <Link
                to={{
                  pathname: `/category/${section.id}/${section.name}`,
                  // search: "?query=abc",
                  // state: { title: "women"},
                  state: { title: section.id },
                }}
                className={`section-card-holder ${
                  section.route === "Men" && "section-card-men"
                }  ${section.route === "Kids" && "section-card-Kids"}  ${
                  section.route === "women" && "section-card-women"
                }`}
                key={idx}
                style={{ backgroundImage: "url(" + section.image + ")" }}
              >
                <div className="card-content">
                <h4 className="card-title">{section.name}</h4>
                <div className="card-bg"></div>
                </div>
                <div className="card-bottom-drop"></div>
              </Link>
                </>
            ))}
        </div>
      </div>
    </div>
  );
}
